import { NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';
import { Leaf as ILeaf } from '../../types';

const sendEmailAllowedNodeTypes = [NodeTypeKeys.endOfFlowNodeType];

export class SendEmailNode extends Leaf {
  public constructor(
    id: string,
    allowedNodeTypes: string[] = sendEmailAllowedNodeTypes,
    position: Position = undefined,
    next: ILeaf = undefined,
    isHidden: boolean = undefined,
  ) {
    super(id, NodeTypeKeys.sendEmailNodeType, allowedNodeTypes, { position, isHidden, next });
  }
}
